import { Plugin } from "..";
import { defaultEventWaveformDataOptions } from "./event-waveform-data-options";
import {
	defaultEventWaveformOptions,
	EventWaveformOptionsV1,
	EventWaveformOptionsV2,
} from "./event-waveform-options";

const id = "event-waveform";

export const EventWaveform: Plugin = {
	id,
	type: "event",
	header: {
		visible: true,
		edit: true,
		fullscreen: true,
	},
	name: "waveform",
	component: defineAsyncComponent(() => import("./EventWaveformPlugin.vue")),
	config: defineAsyncComponent(() => import("./EventWaveformPluginConfig.vue")),
	dataConfig: defineAsyncComponent(() => import("./EventWaveformDataConfig.vue")),
	defaultDataResolver: () => defaultEventWaveformDataOptions,
	defaultOptionsResolver: () => defaultEventWaveformOptions,
	dimension: {
		minHeight: 6,
		minWidth: 4,
	},

	currentVersion: 2,
	migrations: {
		1: ({ data, options }) => {
			if (options == null) {
				return { data, options };
			}

			const v1Options = options as EventWaveformOptionsV1;
			const v2Options: EventWaveformOptionsV2 = {
				...v1Options,
				waveformSeries: {
					vibrationVisible:
						v1Options.waveformSeries.xVisible ||
						v1Options.waveformSeries.yVisible ||
						v1Options.waveformSeries.zVisible,
					oplVisible: v1Options.waveformSeries.oplVisible,
				},
			};

			return { data, options: v2Options };
		},
	},
};
